export enum ConstructionTypeEnum {
  BRICK_BUILDING = 'brick_building',
  CONCRETE_BUILDING = 'concrete_building',
  STEEL_BUILDING = 'steel_building',
}
